import { useEffect, useState } from 'react';
import { builder } from '@builder.io/react';

export function useBuilderIO() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        builder.init(process.env.BUILDERIO_KEY);
        builder.setUserAttributes({
            environment: process.env.ENV,
        });

        setIsLoaded(true);
    }, []);

    return isLoaded;
}
